import { getSite } from "../../global_functions/postgrestApi";
import type { SummaryOverview, SummaryOverviewQueryParams } from "../../types";

export const SITE_SUMMARY_FIELDS: SummaryOverviewQueryParams = [
  "id",
  "ubinPropertyCode",
  "accountId",
  "accountName",
  "gresbAssetId",
  "arcAssetId",
  "energyStarPropertyId",
  "productTier",
  "name",
  "imageKey",
  "status",
  "latitude",
  "longitude",
];

export async function handleRefreshSite(
  siteId: string | number,
  setSiteData: (
    cb: (prev?: SummaryOverview[]) => SummaryOverview[]
  ) => SummaryOverview[] | undefined,
  includeInactive = false,
  fields?: SummaryOverviewQueryParams
) {
  // Retrieve individual site
  const updatedSite = await getSite(siteId, {
    includeInactive,
    fields,
  });
  if (!updatedSite) {
    throw new Error(`Error refreshing Site (siteId: ${siteId})`);
  }

  // Update main sites array with new data
  setSiteData((allSites) => {
    let found = false;
    const updatedSites = (allSites ?? []).map((site) => {
      if (Number(site.id) === Number(siteId)) {
        found = true;
        return updatedSite;
      }
      return site;
    });

    if (updatedSite && !found) updatedSites.push(updatedSite);
    return updatedSites;
  });
}
